<template>
    <header id="home" class="home-banner-area home-3-banner-area position-relative">

        <div id="particles">
            <div class="overlay"></div>
            <div id="hero-area-intro">
                <div class="home-3-hero-content">
                    <h1>Powerful Web Hosting<br>Platform!</h1>
                    <vue-typer
                        :text='["We provide powerful hosting services"]'
                        :repeat='Infinity'
                        :shuffle='false'
                        initial-action='typing'
                        :pre-type-delay='70'
                        :type-delay='70'
                        :pre-erase-delay='2000'
                        :erase-delay='250'
                        erase-style='clear'
                        :erase-on-complete='false'
                        caret-animation='expand'
                    ></vue-typer>
                    <!-- <p>We provide powerful hosting services</p> -->
                    
                    <div class="hero-button-box text-center">
                        <a href="#domain-search" class="js-scroll-trigger theme-button text-capitalize">Start Today</a>
                    </div>
                </div>
                <div class="home-3-hero-img">
                    <img src="../../public/img/home-3-hero-cloud.svg" alt="hero">
                </div>
            </div>
        </div>
        <!-- Effect Start-->
        <img class="bubble slow" src="../../public/img/all-effect-img/Top_bubble.svg" id="pink-side-bubble-1" alt="b">
        <img class="bubble" src="../../public/img/all-effect-img/Bottom_Bubble.svg" id="pink-side-bubble-2" alt="b">
        <img class="bubble slow" src="../../public/img/all-effect-img/Bog-Blob.svg" id="blue-side-bubble-1" alt="b">
        <!-- Effect End-->

        <!-- Wave Effect Start-->
        <div class="footer-wave"></div>
        <!-- Wave Effect End-->

    </header>
</template>

<style scoped >
header{
    background: linear-gradient(to right, rgba(42, 22, 155, 1) 39%, rgba(41, 137, 216, 1) 78%, rgba(44, 212, 217, 1) 95%);
}
.home-3-hero-content h1, .home-3-hero-content p{color:#eee;}
</style>

<script>
import { VueTyper } from 'vue-typer'

export default {
    components: {
        VueTyper
    }
}
</script>